import ResponsiveWebDesign from "../docs/Responsive Web Design - Diseño Web Responsivo - Freecodecamp.png"
import FrontEndDevelopmentLibraries from "../docs/Front End Development Libraries - Freecodecamp.png"
import JavaScriptAlgoritmosYEstructuraDeDatos from "../docs/JavaScript - Algoritmos y Estructura de Datos - Freecodecamp.png"
import VisualizacionDeDatosFCC from "../docs/Visualización de Datos - Freecodecamp.png"

import AprendeJson from "../docs/Aprende JSON - Linkedin.png"

//Los nombres de esta imagenes están invertidos
import VisualizacionDeDatosLinkedin from "../docs/D3.js Avanzado - Linkedin.png"
import D3jsAvanzado from "../docs/Visualización de Datos (D3.js) - Linkedin.png"

import Udemy1 from "../docs/udemy-1.png"
import Udemy2 from "../docs/udemy-2.png"

const article = `
## FreeCodeCamp (4 certificados)

**Responsive Web Design**: ([enlace](https://freecodecamp.org/espanol/certification/juangarciapereira/responsive-web-design))

> <img src="${ResponsiveWebDesign}" width="100%" />

**Front End Development Libraries**: ([enlace](https://freecodecamp.org/certification/juangarciapereira/front-end-development-libraries))
	
> <img src="${FrontEndDevelopmentLibraries}" width="100%" />

**JavaScript Algorithms and Data Structures**: ([enlace](https://freecodecamp.org/certification/juangarciapereira/javascript-algorithms-and-data-structures))

> <img src="${JavaScriptAlgoritmosYEstructuraDeDatos}" width="100%" />

**Data Visualization**: ([enlace](https://freecodecamp.org/certification/juangarciapereira/data-visualization))

> <img src="${VisualizacionDeDatosFCC}" width="100%" />

## CódigoFacilito (3 certificados)

**Curso Profesional de Git**: ([enlace](https://codigofacilito.com/certificates/45664.pdf))

> <iframe src="https://docs.google.com/viewer?srcid=1lNJLn6D1x1mfsnp5Mx350DphDY02AREo&pid=explorer&efh=false&a=v&chrome=false&embedded=true" width="100%" height="400px"></iframe>

**Curso Profesional de Backend**: ([enlace](https://codigofacilito.com/certificates/45663))

> <iframe src="https://docs.google.com/viewer?srcid=1VYaOSWbAKjqYc9XV9k62of2U6L1BAsFM&pid=explorer&efh=false&a=v&chrome=false&embedded=true" width="100%" height="400px"></iframe>

**Curso Profesional de Base de Datos**: ([enlace](https://codigofacilito.com/certificates/39653.pdf))

> <iframe src="https://docs.google.com/viewer?srcid=1aQoVUEMQBVfN9LhLCJ_vNDQKVQxC0qeO&pid=explorer&efh=false&a=v&chrome=false&embedded=true" width="100%" height="400px"></iframe>

## Linkedin (3 certificados)

**Aprende JSON**: ([enlace](https://linkedin.com/learning/certificates/253898b27c57feb056fdf1f3e6796a363a3b021ec18b329746a8f4b29d390d40))

> <img src="${AprendeJson}" width="100%" />

**Visualización de Datos D3.js**: ([enlace](https://linkedin.com/learning/certificates/59bc10e370acabb0f090ee9b5fdb10e81b8a43c8dfcf4af724433f9c95f105c5))

> <img src="${VisualizacionDeDatosLinkedin}" width="100%" />

**D3.js Avandazo**: ([enlace](https://linkedin.com/learning/certificates/782456e93fb8ac644cdde7fc89ad9362e8a13f38a561d7bf18f28b7110f46ad6))

> <img src="${D3jsAvanzado}" width="100%" />

## Udemy

**NOTA:** de estos no tengo los certificados, mi primo los compró y aproveché la oportunidad.

**React JS + Redux + ES6. Completo...**: ([enlace](https://www.udemy.com/course/react-js-redux-es6-completo-de-0-a-experto-espanol/))

> <img src="${Udemy1}" width="100%" />

**Web personal MERN Full Stack...**: ([enlace](https://www.udemy.com/course/web-personal-mern-full-stack-mongodb-express-react-node/))

> <img src="${Udemy2}" width="100%" />
`;

export default article